import { postLocationOpenOnMap } from '@/components/flutter/ExternalMap';

export type LocationData = {
  lat: number;
  lon: number;
  title: string;
};

function isPlatformLocationOpenAvailable(): boolean {
  return window.platformLocationOpen !== undefined || window.flutter_inappwebview != undefined;
}

export function openLocation(location: LocationData) {
  if (isPlatformLocationOpenAvailable()) {
    postLocationOpenOnMap(location, false);
    return;
  }

  const locationUrl = `https://www.google.com/maps?q=${location.lat},${location.lon}`;
  window.open(locationUrl, '_blank', 'noopener=true,noreferrer=true');
}

export function routeLocation(location: LocationData) {
  if (isPlatformLocationOpenAvailable()) {
    postLocationOpenOnMap(location, true);
    return;
  }

  const locationUrl = `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lon}&travelmode=driving`;
  window.open(locationUrl, '_blank', 'noopener=true,noreferrer=true');
}
